module.exports = __webpack_public_path__ + "img/5.fba9162b.png";